export const filterColumnsByEventType = ({ columns, type }: { columns: any[]; type: string }): any[] => {
  if (!!columns && !!columns?.length && type?.toLowerCase() !== 'online')
    return columns?.filter((item) => !['event_code', 'event_link', 'event_password'].includes(item?.key));
  return columns;
};
